<template>
  <section
    class="relative h-screen flex flex-col justify-normal md:justify-center text-center text-white py-0 px-3"
  >
    <div
      class="-mt-16 after:content-[''] after:bg-secondary/40 after:z-0 after:absolute after:left-0 after:right-0 after:h-full after:w-full absolute top-0 left-0 w-full h-full overflow-hidden"
    >
      <img :src="poster" class="w-full h-full object-cover md:hidden" />
      <video
        ref="heroVideo"
        class="min-w-full min-h-full absolute object-cover top-1/2 left-1/2 transform-gpu -translate-x-1/2 -translate-y-1/2 hidden md:block"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
      >
        <source :src="videoWebm" type="video/webm" />
        <source :src="videoMp4" type="video/mp4" />
      </video>
    </div>
    <div class="z-10 w-full mt-10 md:-mt-24 md:mb-10">
      <div class="container">
        <div class="flex text-left">
          <div class="md:w-2/3 xl:w-1/2 2xl:w-3/6 space-y-3">
            <text-h1 class="">{{ header }}</text-h1>
            <text-lead>{{ lead }}</text-lead>
            <ui-button
              variant="primary"
              size="xl"
              class="w-full md:w-1/2 cursor-pointer"
              @click="onClick"
            >
              Book an Appointment
            </ui-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const heroVideo = ref(null);

defineProps({
  videoWebm: {
    type: String,
    default: "",
  },
  videoMp4: {
    type: String,
    default: "",
  },
  poster: {
    type: String,
    default: "",
  },
  header: {
    type: String,
    default: "",
  },
  lead: {
    type: String,
    default: "",
  },
  onClick: {
    type: Function,
    default: () => {},
  },
});

onMounted(() => {
  // Ensure video plays on mount
  if (heroVideo.value) {
    heroVideo.value.muted = true;
    heroVideo.value.play().catch((error) => {
      console.warn('Video autoplay failed:', error);
    });
  }
});
</script>

